import type { ValidationErrors } from 'types';

export const getNestedErrorMessage = (errors: ValidationErrors) =>
  Object.keys(errors).length > 0 ? JSON.stringify(errors, null, 4) : '';
